import React, {Component} from "react";
import TopNav from "../common/nav/TopNav";
import Footer from "../common/Footer";
import PageBlock from "../common/PageBlock";
import ApiKeysPanel from "./account/ApiKeysPanel";
import SubscriptionProvider from "./product/SubscriptionProvider";
import SubscriptionStatus from "./product/SubscriptionStatus";
import {Link} from "react-router";

class Account extends Component {
    constructor() {
        super();

        this.state = {subscription: {}};
    }

    render() {
        return (
            <div>
                <TopNav tab="account"/>

                <PageBlock>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Account</h1>
                                <h4 className="text-muted">Security and subscription information.</h4>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12 m-b-sm">
                                <h3 className="page-subsection">Subscription plan</h3>

                                <SubscriptionProvider callback={(subscription) => this.setState({subscription: subscription})}/>
                                <SubscriptionStatus subscription={this.state.subscription}/>

                                <Link to="/subscription" className='btn btn-primary m-b-xs'>View or change plan</Link>
                            </div>
                        </div>

                        <ApiKeysPanel/>
                    </div>
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default Account;



// WEBPACK FOOTER //
// ./src/modules/views/Account.js